module.exports = __webpack_public_path__ + "static/img/9.367f906.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/eng/9.png
// module id = hXku
// module chunks = 0